import { render, staticRenderFns } from "./ProductStat.vue?vue&type=template&id=28c084a9&scoped=true&"
import script from "./ProductStat.vue?vue&type=script&lang=js&"
export * from "./ProductStat.vue?vue&type=script&lang=js&"
import style0 from "./ProductStat.vue?vue&type=style&index=0&id=28c084a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c084a9",
  null
  
)

export default component.exports